import IconMessageSquare from "@src/assets/icons/lucide/message-square.svg?react";
import { ROUTES } from "@src/common/constants";
import { toggleAgentChatDrawer } from "@src/components/agent-chat/agent-chat-drawer-controls";
import { NavBarMenuButtonItem } from "@src/components/navigation/nav-bar-menu-button-item/nav-bar-menu-button-item";
import { NativeLikeTooltip as Tooltip } from "@src/components/ui/native-like-tooltip";
import clsx from "clsx";
import { useLocation } from "react-router-dom";

export function AgentChatNavBarEntry() {
	const location = useLocation();
	const isAskHome =
		location.pathname === ROUTES.ask ||
		location.pathname.toLowerCase().startsWith("/chat-");
	if (isAskHome) {
		return null;
	}

	return (
		<NavBarMenuButtonItem
			label="Agent chat"
			icon={<IconMessageSquare />}
			onClick={() => {
				toggleAgentChatDrawer("agent");
			}}
		/>
	);
}

export function AgentChatMenuBarEntry() {
	const location = useLocation();
	const isAskHome =
		location.pathname === ROUTES.ask ||
		location.pathname.toLowerCase().startsWith("/chat-");
	if (isAskHome) {
		return null;
	}

	return (
		<Tooltip label="Agent chat">
			<button
				type="button"
				aria-label="Open agent chat"
				title="Open agent chat"
				className={clsx(
					"inline-flex h-10.5 w-10.5 shrink-0",
					"items-center justify-center",
					"leading-none rounded-md border hover:shadow-md",
					"text-brand-primary",
				)}
				onClick={() => {
					toggleAgentChatDrawer("agent");
				}}
			>
				<IconMessageSquare width={24} height={24} strokeWidth={1.5} />
			</button>
		</Tooltip>
	);
}
